import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { AppState, Dispatch } from 'store/types'
import { logout } from 'ducks/auth/operations'
import { getProfile, putProfile } from 'ducks/profile/operations'
import ChangePasswordForm from 'components/profile/ChangePasswordForm'
import ProfileForm from 'components/profile/ProfileForm'
import { fetchGenders } from 'ducks/references/operations'
import { changePassword } from 'ducks/auth/operations'
import { camelCaseToSentence } from '../../utils/helpers'

class ProfilePage extends Component<Props> {
  componentDidMount(): void {
    this.props.getProfile()
    this.props.fetchGenders()
  }
  render() {
    const { profile, putProfile: saveProfile, genders, changePassword } = this.props

    return (
      <WrapBlock>
        <HeadTitle>
          <Title>My profile</Title>
        </HeadTitle>
        <ProfileForm
          profile={profile}
          onSaveProfile={saveProfile}
          genders={genders}
        />
        <ChangePasswordForm
          isProcessing={this.props.auth.isPasswordChanging}
          errorMessage={this.props.auth.errors.changePassword || ''}
          onChangePassword={changePassword}
        />
      </WrapBlock>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps & ReceivedProps

const mapStateToProps = (state: AppState) => ({
  isAccountCreated: state.auth.registrationData,
  profile: state.profile.profile,
  genders: state.references.genders.data.map(item => ({
    value: item,
    label: camelCaseToSentence(item)
  })),
  auth: state.auth
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ 
    logout, putProfile, getProfile, fetchGenders, changePassword 
  }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfilePage)

const WrapBlock = styled.div``

const Title = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0;
`

const HeadTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`
